// extracted by css-extract-rspack-plugin
export default {"premiumContainer":"premium-container--YNTLa4hq3bga7xCT"};